import get from 'lodash/get';
import axios from 'axios';
import log from '../../../services/logger_service';

export default function loadParselyTracker(currentState) {
  if (window.PARSELY && window.PARSELY.beacon) {
    // Sometimes multiple entries of same post appear on dashboard with weird query strings, this is to filter our all query strings.
    let url = window.location.href.split('?');
    url = get(url, '[0]', window.location.href);

    const navHistory = get(currentState, 'config.navHistory') || [];

    // Temporarly solution to figure out why parsely.js is fired before head.js, we need head to set document.title first before parsely fires in order for parsely to collect the right title.
    setTimeout(() => {
      window.PARSELY.beacon.trackPageView({
        url,
        urlref: navHistory[navHistory.length - 1],
        js: 1
      });
    }, 200);
  }
}

// Builds a profile of the user's recommendation list, doc https://www.parse.ly/help/api/recommendations/#get-related
export function trainParselyProfile(url) {
  if (window.PARSELY && window.PARSELY.config) {
    const profileURL = url || window.location.href;
    const uuid = get(window, 'PARSELY.config.uuid');

    // Train user base on UUID and post
    axios
      .get(
        `https://api.parsely.com/v2/profile?apikey=fastcompany.com&url=${profileURL}&uuid=${uuid}`
      )
      .catch(error => {
        log.error('Parsely profile trainer error', error);
      });
  }
}
